import { useElementAboveViewportTop } from "@wags/tanstack-start/browser";
import { useState } from "react";

export const PROVIDER_SHEET_CLASS =
    "relative isolate pt-12 md:pt-16 before:absolute before:inset-x-0 before:top-0 before:-bottom-12 before:-z-10 before:left-1/2 before:w-screen before:-translate-x-1/2 before:rounded-t-3xl before:bg-true-white before:shadow-[0_-4px_16px_rgba(0,0,0,0.04)] md:before:-bottom-40";

export const PROVIDER_CHROME_CLASS =
    "bg-maltese-white transition-colors duration-200 motion-reduce:transition-none";

export const PROVIDER_BREADCRUMB_CLASS =
    "[&>nav]:bg-maltese-white [&>nav]:transition-colors [&>nav]:duration-200 motion-reduce:[&>nav]:transition-none";

export const PROVIDER_SHELL_CLASS =
    "has-[[data-header-on-sheet]]:[&_[data-sheet-chrome]]:bg-true-white has-[[data-header-on-sheet]]:[&_[data-sheet-breadcrumb]>nav]:bg-true-white";

export function ProviderSheetSentinel() {
    const [sentinel, setSentinel] = useState<HTMLDivElement | null>(null);
    const headerOnSheet = useElementAboveViewportTop(sentinel);
    return (
        <div
            ref={setSentinel}
            data-header-on-sheet={headerOnSheet ? "" : undefined}
            className="pointer-events-none absolute -top-[calc(69px+env(safe-area-inset-top))] left-0 h-px w-px md:-top-25.75"
        />
    );
}
